var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdt-radio",attrs:{"data-test":_vm.camelToKebabCase(_vm.testKey)},on:{"click":_vm.onChange}},[_c('input',{attrs:{"type":"radio"},domProps:{"checked":_vm.checked}}),_c('label',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }